module.exports = __webpack_public_path__ + "img/编组 28@2x.cb533301.png";